export default class GetMediaDownloadToken {
    public constructor(
        private readonly url: string
    ) {
    }

    async get(uuid: string, token: string): Promise<string | null> {
        const controller: AbortController = new AbortController();
        const timeoutId: NodeJS.Timeout = setTimeout(() => controller.abort(), 10000);
        const url: string = this.url + "/media/" + uuid + "/get-download-token";

        try {
            const response: Response = await this.getResponse(controller, url, token);
            clearTimeout(timeoutId);
            if (!response.ok) {
                return null;
            }

            return this.getTokenFromResponse(response);
        } catch (error) {
            console.warn("Error fetching after getMediaDownloadToken: ", error);
        }

        return null;
    }

    private async getResponse(
        controller: AbortController,
        url: string,
        token: string
    ): Promise<Response> {
        return await fetch(url, {
            signal: controller.signal,
            headers: {
                "content-type": "application/json",
                authorization: "Bearer " + token
            },
            method: "POST",
        });
    }

    private async getTokenFromResponse(response: Response): Promise<string> {
        const responseJson = await response.json();
        if (responseJson.status === 403 || responseJson.status === 401) {
            localStorage.clear();
            window.location.href = "/";
        }

        return responseJson.token;
    }
}